module.exports = __webpack_public_path__ + "img/icon-num2.870b479c.png";